import { useEffect } from "react";
import type { ChartPoint } from "../utils/types";
import type { ChartConfig, ChartKey } from "../utils/settings";

type Args = {
  chartRefs: React.MutableRefObject<Array<any>>;
  chartConfigs: ChartConfig[];
  chartPoints: ChartPoint[];
  selectedChartIdx: number;
  selectedXMsForPlugins: number | null;
  getSeriesY: (p: ChartPoint, key: ChartKey) => number | null;
};

// 選択中の時刻とハイライト点を全チャートへ同期するhook。
export const useBpsLogChartSelectionSync = ({
  chartRefs,
  chartConfigs,
  chartPoints,
  selectedChartIdx,
  selectedXMsForPlugins,
  getSeriesY,
}: Args) => {
  useEffect(() => {
    const selectedPt = chartPoints[selectedChartIdx] ?? null;
    for (let idx = 0; idx < chartConfigs.length; idx++) {
      const ref = chartRefs.current[idx] as any;
      const chart = ref?.chart ?? ref;
      if (!chart) continue;

      chart.$activeXMs = selectedXMsForPlugins;

      const key = chartConfigs[idx]?.key;
      const y =
        selectedPt && key
          ? getSeriesY(selectedPt, key)
          : (null as number | null);
      chart.$highlightPoint =
        typeof selectedXMsForPlugins === "number" &&
        typeof y === "number" &&
        Number.isFinite(y)
          ? {
              xMs: selectedXMsForPlugins,
              y,
              radius: 1,
              fill: "#ff9800",
              stroke: "#ff9800",
              lineWidth: 2,
            }
          : null;

      if (typeof chart.draw === "function") {
        chart.draw();
      }
    }
  }, [
    chartConfigs,
    chartPoints,
    chartRefs,
    getSeriesY,
    selectedChartIdx,
    selectedXMsForPlugins,
  ]);
};
